import type { Application } from "features/onboarding/types";

export const enum Action {
    ApproveApplication,
    RejectApplication,
    IdleApplication,
    DeleteApplication,
    ViewOnboardingLogs
};

export type ApplicationTableResourceContext = {
    readonly action: Action;
    readonly row: Application;
};
